import moment from 'moment-timezone'

export const UTCDateToCountryDate = (date: string) => {
  const fecha = moment.utc(date).format()
  let dateRet = ''
  if (String(process.env.REACT_APP_COUNTRY) === 'MEX') {
    dateRet = moment(fecha).tz('America/Mexico_City').format('DD-MM-YYYY HH:mm:ss')
  }
  if (String(process.env.REACT_APP_COUNTRY) === 'PER') {
    dateRet = moment(fecha).tz('America/Lima').format('DD-MM-YYYY HH:mm:ss')
  }
  if (String(process.env.REACT_APP_COUNTRY) === 'CHL') {
    dateRet = moment(fecha).tz('America/Santiago').format('DD-MM-YYYY HH:mm:ss')
  }
  return dateRet
}

export const getTimeDiff = () => {
  let dateRet = ''
  if (String(process.env.REACT_APP_COUNTRY) === 'MEX') {
    dateRet = moment().tz('America/Mexico_City').format('Z')
  }
  if (String(process.env.REACT_APP_COUNTRY) === 'PER') {
    dateRet = moment().tz('America/Lima').format('Z')
  }
  if (String(process.env.REACT_APP_COUNTRY) === 'CHL') {
    dateRet = moment().tz('America/Santiago').format('Z')
  }
  return dateRet
}
